import { Accordion, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import { DetailSection } from '../DetailSection';
import { FactCard } from './FactCard';
import { sortFactsForDisplay, type FactLike } from './factTypes';

type EntityKind = 'subject' | 'poi';

const SECTION_COPY: Record<
    EntityKind,
    { title: string; hint: string; empty: string }
> = {
    subject: {
        title: 'detail.subjectComputedFacts',
        hint: 'detail.subjectComputedFactsHint',
        empty: 'detail.noSubjectComputedFacts',
    },
    poi: {
        title: 'detail.poiComputedFacts',
        hint: 'detail.poiComputedFactsHint',
        empty: 'detail.noPoiComputedFacts',
    },
};

export function ComputedFactsSection({
    entityKind,
    facts,
}: {
    entityKind: EntityKind;
    facts: FactLike[];
}) {
    const { t } = useTranslation();
    const copy = SECTION_COPY[entityKind];
    const sorted = sortFactsForDisplay(facts);

    return (
        <DetailSection
            title={t(copy.title, { count: facts.length })}
            description={t(copy.hint)}
        >
            {sorted.length === 0 ? (
                <Text size="sm" c="dimmed">
                    {t(copy.empty)}
                </Text>
            ) : (
                <Accordion variant="separated" multiple>
                    {sorted.map((fact) => (
                        <FactCard key={fact.id} fact={fact} />
                    ))}
                </Accordion>
            )}
        </DetailSection>
    );
}
